import React from 'react';
import {Alert, Button, Divider, Stack, TextField, Typography} from '@mui/material';
import {AutoAwesome} from '@mui/icons-material';
import PolicySelector from './PolicySelector';

/**
 * Generate Initial Version View
 * Contains the form for generating initial disclosure version
 */
const GenerateInitialVersionView = ({
                                        instructions,
                                        onInstructionsChange,
                                        selectedPolicy,
                                        onPolicyChange,
                                        onGenerate
                                    }) => {
    return (
        <Stack overflow={'auto'} flexGrow={1} p={3} spacing={3}>

            <Typography variant="body1">
                Generate an initial disclosure version based on the source document, instructions, and
                selected policy.
            </Typography>

            {/* Apply Policy Section */}
            <PolicySelector
                selectedPolicy={selectedPolicy}
                onPolicyChange={onPolicyChange}
            />

            {/* Instructions Section */}
            <Stack spacing={1}>
                <Typography variant="h6" fontWeight="medium">
                    Additional Instructions
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>
                    Provide any specific guidance for generating the disclosure.
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    value={instructions}
                    onChange={onInstructionsChange}
                    placeholder="Enter any additional instructions..."
                    variant="outlined"
                    size="small"
                />
            </Stack>

            <Divider/>

            {/* Generate Button Section */}
            <Stack spacing={2}>

                <Alert severity="info">
                    This won't replace your current content. Opens in a modal for review before applying.
                </Alert>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={onGenerate}
                    startIcon={<AutoAwesome/>}
                    size="large"
                >
                    Generate Initial Version
                </Button>
            </Stack>
        </Stack>
    );
};

export default GenerateInitialVersionView;
